import React from 'react';
import { CreditCard } from 'lucide-react';
import Button from '../../../components/ui/Button';

const PaymentMethod = ({ card, isDefault, onSetDefault, onRemove }) => {
  return (
    <div className="flex items-center justify-between p-4 border rounded-lg">
      <div className="flex items-center space-x-4">
        <div className="p-2 bg-gray-100 rounded-full">
          <CreditCard className="h-6 w-6 text-gray-600" />
        </div>
        <div>
          <p className="font-medium">•••• •••• •••• {card.last4}</p>
          <p className="text-sm text-gray-600">Expires {card.expMonth}/{card.expYear}</p>
        </div>
      </div>
      <div className="flex items-center space-x-2">
        {isDefault ? (
          <span className="text-sm text-green-600">Default</span>
        ) : (
          <Button variant="secondary" size="sm" onClick={onSetDefault}>
            Set as Default
          </Button>
        )}
        <Button variant="secondary" size="sm" onClick={onRemove}>
          Remove
        </Button>
      </div>
    </div>
  );
};

export default PaymentMethod;